<header class="top-header">
  <div class="header-left">
    <!-- ALLPLAN Logo Section -->
    <div class="allplan-section">
      <div class="allplan-logo">
        <svg viewBox="0 0 119.793 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_allplan)">
            <path d="M11.9636 0H7.99903L0 24H3.37414L9.70355 3.44395H9.77336L16.0359 24H20.0005L11.9636 0Z" fill="white"/>
            <path d="M22.5744 24V0H26.3993V21.4956H35.2681V24H22.5714H22.5744Z" fill="white"/>
            <path d="M37.5312 24V0H41.3562V21.4956H50.225V24H37.5283H37.5312Z" fill="white"/>
            <path d="M52.4882 24V0H57.4272C62.2615 0 66.7148 0.730093 66.7148 6.60865C66.7148 12.4872 62.2295 13.4267 57.4272 13.4267H56.3132V24H52.4882ZM57.4272 11.1317C60.7664 11.1317 62.8869 10.4366 62.8869 6.60865C62.8869 2.78075 60.6617 2.29499 57.4272 2.29499H56.3132V11.1288H57.4272V11.1317Z" fill="white"/>
            <path d="M92.5936 0H88.626L81.4618 21.4956H72.66V0H68.835V24H84.0011L90.3306 3.44395H90.4004L96.6629 24H100.627L92.5936 0Z" fill="white"/>
            <path d="M115.829 24L106.02 4.45328H105.951V24H102.786V0H107.03L116.559 18.9912H116.629V0H119.793V24H115.829Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_allplan">
              <rect fill="white" height="24" width="119.793"/>
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <!-- Angled Divider -->
    <div class="angled-divider">
      <svg viewBox="0 0 16.08 48" fill="none" preserveAspectRatio="none">
        <rect fill="#B4DAFF" height="48" width="16.08"/>
        <path d="M0 0L16.08 48H0V0Z" fill="#0066CC"/>
      </svg>
    </div>
    <!-- Amplify Section -->
    <div class="amplify-section">
      <span class="amplify-text">Amplify</span>
    </div>
    <!-- Trailing Angled Divider -->
    <div class="angled-divider trailing">
      <svg viewBox="0 0 16.08 48" fill="none" preserveAspectRatio="none">
        <path d="M0 0L16.08 48H0V0Z" fill="#B4DAFF"/>
      </svg>
    </div>
  </div>
  <div class="header-right">
    @if (mode === 'landing') {
      <button class="login-link" type="button" (click)="login()">{{ 'LANDING.LOGIN' | translate }}</button>
    } @else {
      <button class="settings-btn" type="button" (click)="openSettings()" [attr.aria-label]="'HEADER.SETTINGS' | translate">
        <svg width="21.5" height="18" viewBox="0 0 21.5 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.25 3.75C7.83579 3.75 7.5 3.41421 7.5 3C7.5 2.58579 7.83579 2.25 8.25 2.25H20.75C21.1642 2.25 21.5 2.58579 21.5 3C21.5 3.41421 21.1642 3.75 20.75 3.75H8.25ZM0.75 3.75C0.335787 3.75 0 3.41421 0 3C0 2.58579 0.335787 2.25 0.75 2.25H3.25C3.66421 2.25 4 2.58579 4 3C4 3.41421 3.66421 3.75 3.25 3.75H0.75Z" fill="#46494D"/>
          <path d="M7.25 3C7.25 2.17157 6.57843 1.5 5.75 1.5C4.92157 1.5 4.25 2.17157 4.25 3C4.25 3.82843 4.92157 4.5 5.75 4.5V6C4.09315 6 2.75 4.65685 2.75 3C2.75 1.34315 4.09315 0 5.75 0C7.40685 0 8.75 1.34315 8.75 3C8.75 4.65685 7.40685 6 5.75 6V4.5C6.57843 4.5 7.25 3.82843 7.25 3Z" fill="#46494D"/>
          <path d="M18.25 9.75C17.8358 9.75 17.5 9.41421 17.5 9C17.5 8.58579 17.8358 8.25 18.25 8.25H20.75C21.1642 8.25 21.5 8.58579 21.5 9C21.5 9.41421 21.1642 9.75 20.75 9.75H18.25ZM0.75 9.75C0.335787 9.75 0 9.41421 0 9C0 8.58579 0.335787 8.25 0.75 8.25H13.25C13.6642 8.25 14 8.58579 14 9C14 9.41421 13.6642 9.75 13.25 9.75H0.75Z" fill="#46494D"/>
          <path d="M17.25 9C17.25 8.17157 16.5784 7.5 15.75 7.5C14.9216 7.5 14.25 8.17157 14.25 9C14.25 9.82843 14.9216 10.5 15.75 10.5V12C14.0931 12 12.75 10.6569 12.75 9C12.75 7.34315 14.0931 6 15.75 6C17.4069 6 18.75 7.34315 18.75 9C18.75 10.6569 17.4069 12 15.75 12V10.5C16.5784 10.5 17.25 9.82843 17.25 9Z" fill="#46494D"/>
          <path d="M11.25 15.75C10.8358 15.75 10.5 15.4142 10.5 15C10.5 14.5858 10.8358 14.25 11.25 14.25H20.75C21.1642 14.25 21.5 14.5858 21.5 15C21.5 15.4142 21.1642 15.75 20.75 15.75H11.25ZM0.75 15.75C0.335787 15.75 0 15.4142 0 15C0 14.5858 0.335787 14.25 0.75 14.25H6.25C6.66421 14.25 7 14.5858 7 15C7 15.4142 6.66421 15.75 6.25 15.75H0.75Z" fill="#46494D"/>
          <path d="M10.25 15C10.25 14.1716 9.57843 13.5 8.75 13.5C7.92157 13.5 7.25 14.1716 7.25 15C7.25 15.8284 7.92157 16.5 8.75 16.5V18C7.09315 18 5.75 16.6569 5.75 15C5.75 13.3431 7.09315 12 8.75 12C10.4069 12 11.75 13.3431 11.75 15C11.75 16.6569 10.4069 18 8.75 18V16.5C9.57843 16.5 10.25 15.8284 10.25 15Z" fill="#46494D"/>
        </svg>
      </button>
      @if (showUserMenu && hasUser) {
        <div class="user-dropdown" (clickOutside)="closeUserMenu()">
          <button class="user-button" type="button" (click)="toggleUserMenu()">
            <div class="user-avatar">
              @if (currentUserAvatarUrl) {
                <img [src]="currentUserAvatarUrl" [alt]="currentUserName || 'User'" />
              } @else {
                <svg viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="11.25" stroke="#2F3133" stroke-width="1.5"/>
                  <circle cx="12" cy="6.25" r="2.5" stroke="#2F3133" stroke-width="1.5"/>
                  <path d="M12 11.25C15.344 11.25 17.6197 14.3084 17.7432 17.709C17.6851 17.7688 17.6163 17.8432 17.5312 17.9238C17.2591 18.1816 16.8546 18.5289 16.334 18.876C15.2899 19.572 13.8082 20.25 12 20.25C10.1918 20.25 8.71012 19.572 7.66602 18.876C7.14543 18.5289 6.74087 18.1816 6.46875 17.9238C6.38346 17.843 6.314 17.7688 6.25586 17.709C6.37931 14.3084 8.65604 11.25 12 11.25Z" stroke="#2F3133" stroke-width="1.5"/>
                </svg>
              }
            </div>
            <span>{{ currentUserName || 'User' }}</span>
          </button>

          @if (isUserMenuOpen) {
            <div class="user-menu">
              <button class="user-menu-item" type="button" (click)="logout()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="logout-icon">
                  <path d="m9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" x2="9" y1="12" y2="12"/>
                </svg>
                <span>{{ 'HEADER.LOGOUT' | translate }}</span>
              </button>
            </div>
          }
        </div>
      }
    }
  </div>
</header>

<app-settings-modal
  [visible]="isSettingsModalOpen"
  [initialSettings]="globalSettingsForModal"
  (saved)="onSettingsSaved($event)"
  (cancelled)="closeSettings()">
</app-settings-modal>
